import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBlockService } from './alertblock.service';
import { AuAction } from '../../action/au.action';
import { PageService } from '../../models/page.service';
import { MessageService } from '../../service/message.service';
var AlertBlockComponent = /** @class */ (function () {
    function AlertBlockComponent(router, route, action, message, page, service) {
        this.router = router;
        this.route = route;
        this.action = action;
        this.message = message;
        this.page = page;
        this.service = service;
        this.componentName = AlertBlockComponent.name;
        this.messages = [];
        this.modal = false;
    }
    AlertBlockComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.service.observable.subscribe(function (messages) {
            var modalIsOpened = $('body > div.remodal-wrapper').hasClass('remodal-is-opened');
            _this.messages = [];
            if (messages.length > 0 && ((modalIsOpened && _this.modal) || (!modalIsOpened && !_this.modal))) {
                _this.messages = messages;
            }
        });
    };
    AlertBlockComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    AlertBlockComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'alertblock',
                    template: "<div *ngIf=\"messages.length > 0\" class=\"alertBlock\" id=\"alertBlock\">\n  <ul>\n    <li *ngFor=\"let message of messages\">{{ message }}</li>\n  </ul>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    AlertBlockComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AlertBlockService }
    ]; };
    AlertBlockComponent.propDecorators = {
        modal: [{ type: Input }]
    };
    return AlertBlockComponent;
}());
export { AlertBlockComponent };
//# sourceMappingURL=alertblock.component.js.map